module.exports = __webpack_public_path__ + "static/media/logo-iso27001.8cdcb44f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-logos/logo-iso27001.jpg
// module id = 2325
// module chunks = 17